export const TITLE_SLUG_WE_ARE_LOVING = 'we-re-loving';
export const TITLE_SLUG_CASHBACK = 'cashback';
export const TITLE_SLUG_TRANDING = 'trending';
export const TITLE_SLUG_FEATURED = 'featured';
